module.exports = __webpack_public_path__ + "img/image-2.5a983bfd.png";